<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="home" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">
          {{ this.$store.getters.TRANSLATIONS["car_request"] }}
        </p>
      </div>
      <p class="content_title">
        <span v-if="isPaymentDone">
          {{ this.$store.getters.TRANSLATIONS["thank_you_for_payment"] }}
          <br />{{ this.$store.getters.TRANSLATIONS["to_get_your_car"] }}
        </span>
        <span v-if="isMultiplePayments">
          {{ this.$store.getters.TRANSLATIONS["partially_paid"] }}
          <br />{{
            this.$store.getters.TRANSLATIONS["to_make_rest_of_payments"]
          }}
        </span>
        {{ this.$store.getters.TRANSLATIONS["head_to_valet"] }}
        <br />
        {{
          this.$store.getters.PICKUP_LOCATION
            ? this.$store.getters.PICKUP_LOCATION.toUpperCase()
            : ""
        }}
      </p>
      <p></p>
    </div>
    <div class="footer" v-if="!loading">
      <button
        v-on:click="pay()"
        v-if="!isPaymentDone && !isMultiplePayments"
        class="button pay"
      >
        {{ this.$store.getters.TRANSLATIONS["pay_for_parking"] }}
      </button>
      <button v-on:click="cancel()" class="button cancel">
        {{ this.$store.getters.TRANSLATIONS["cancel"] }}
      </button>
      <button v-on:click="home()" class="button back_button">
        {{ this.$store.getters.TRANSLATIONS["back_home"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created: function () {
    console.log("/components/RequestCar/InProgress.vue");
    if (
      this.$route.query &&
      this.$route.query.token &&
      this.$route.query.vehicleId
    ) {
      const parkendaToken = this.$route.query.token;
      const vehicleId = this.$route.query.vehicleId;
      this.$store.dispatch("SAVE_USER_HAVE_ACTIVE_PARKING", true);
      this.$store.dispatch("SAVE_TOKEN", parkendaToken);
      this.$storage.set("parkendaToken", parkendaToken);
      // const timeout = setTimeout(() => {
      this.loading = true;
      // }, 0);
      this.$http
        .get(`${process.env.SERVER_URL}/2600ED9F52C14E3D929B271668DE977E`, {
          headers: {
            "x-access-token": parkendaToken
          }
        })
        .then((response) => {
          this.$store.dispatch("SAVE_USER", response.data);
          this.$store.dispatch("SAVE_TOKEN", parkendaToken);
        })
        .then(() => {
          return this.$http
            .get(
              `${process.env.SERVER_URL}/F0B659FCE0414D869F2A05C012553E82/${vehicleId}`,
              {
                headers: {
                  "x-access-token": parkendaToken
                }
              }
            )
            .then((response) => {
              console.log("Requested vehicle info response:");
              console.log(response);
              if (response && response.data) {
                this.$store.dispatch(
                  "SAVE_REQUESTED_VEHICLE_INFO",
                  response.data
                );
                if (response.data.status === "P") {
                  this.isPaymentDone = true;
                } else if (response.data.paymentsHistory.length > 0) {
                  // This is multiple payments case. We need to redirect user to valet.
                  this.isMultiplePayments = true;
                }
              } else {
                console.log("Request has failed:");
                console.log(response.data);
              }
            });
        })
        .then(() => {
          return this.$http
            .get(
              `${process.env.SERVER_URL}/68E437DE09054D61957C712C23FDECD0/${vehicleId}`,
              {
                headers: {
                  "x-access-token": parkendaToken
                }
              }
            )
            .then((response) => {
              console.log("Get active parking response:");
              console.log(response);
              if (response.data && response.data.createdAt) {
                this.$store.dispatch(
                  "SAVE_PICKUP_LOCATION",
                  response.data.location
                );
                response.data.customerId = this.$store.getters.USER.id;
                response.data.flagIsManual =
                  response.data.flagIsManual === 0 ? false : true;
                response.data.flagIsExotic =
                  response.data.flagIsExotic === 0 ? false : true;
                response.data.flagIfSelfParker =
                  response.data.flagIfSelfParker === 0 ? false : true;
                this.$store.dispatch("SAVE_REQUESTED_VEHICLE", response.data);
                this.parkingLocation = response.data.location;
                this.enterTime = response.data.enterTime;
                // this.$router.push("/parkingReceipt");
              } else {
                this.$storage.remove("parkendaToken");
                this.$router.push("/login");
              }
            });
        })
        .catch((e) => {
          this.$storage.remove("parkendaToken");
          this.$router.push("/login");
        })
        .finally(() => {
          // clearTimeout(timeout);
          this.loading = false;
        });
    } else {
      if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
        this.$router.push("/login");
      } else {
        // const timeout = setTimeout(() => {
        this.loading = true;
        // }, 0);
        this.$http
          .get(
            `${process.env.SERVER_URL}/F0B659FCE0414D869F2A05C012553E82/${this.$store.getters.REQUESTED_VEHICLE.id}`,
            {
              headers: {
                "x-access-token": this.$storage.get("parkendaToken")
              }
            }
          )
          .then((response) => {
            console.log("Requested vehicle info response:");
            console.log(response);
            if (response && response.data) {
              this.$store.dispatch(
                "SAVE_REQUESTED_VEHICLE_INFO",
                response.data
              );
              if (response.data.status === "P") {
                this.isPaymentDone = true;
              } else if (response.data.paymentsHistory.length > 0) {
                // This is multiple payments case. We need to redirect user to valet.
                this.isMultiplePayments = true;
              }
            } else {
              console.log("Request has failed:");
              console.log(response.data);
            }
          })
          .catch((error) => {
            let text =
              this.$store.getters.TRANSLATIONS["requested_vehicle_info"];
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              text = error.response.data.message;
            }
            console.log(text);
          })
          .finally(() => {
            // clearTimeout(timeout);
            this.loading = false;
          });
      }
    }
  },
  data() {
    return {
      loading: false,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      isPaymentDone: false,
      isMultiplePayments: false,
      home: () => {
        this.$router.push("/appRating");
      },
      pay() {
        this.$router.push("/parkingReceipt");
      },
      cancel: () => {
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.$http
          .post(
            `${process.env.SERVER_URL}/F71C2C7054F24DE5A9204FBF3BD70455/${this.$store.getters.USER.barcode}`,
            {
              vehicle: this.$store.getters.REQUESTED_VEHICLE
            },
            {
              headers: {
                "x-access-token": this.$storage.get("parkendaToken")
              }
            }
          )
          .then((response) => {
            console.log("Cancel car request response:");
            console.log(response);

            if (response && response.data && response.data.status) {
              switch (response.data.status) {
                case 0:
                  {
                    this.$modal.show("dialog", {
                      text: this.$store.getters.TRANSLATIONS[
                        "cancel_car_requst_has_failed"
                      ],
                      buttons: [
                        {
                          title: "OK",
                          handler: () => {
                            this.$router.push("/login");
                          }
                        }
                      ]
                    });
                  }
                  break;
                case 1:
                  {
                    this.$modal.show("dialog", {
                      text: "Request has canceled",
                      buttons: [
                        {
                          title: "OK",
                          handler: () => {
                            this.$router.push("/hello");
                          }
                        }
                      ]
                    });
                  }
                  break;
              }
            } else {
              console.log("Cancel car request has failed:");
              console.log(response.data);
            }
          })
          .catch((error) => {
            let text =
              this.$store.getters.TRANSLATIONS["cancel_car_requst_has_failed"];
            if (
              error.response &&
              error.response.data &&
              error.response.data.message
            ) {
              text = error.response.data.message;
            }
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK",
                  handler: () => {
                    this.$storage.remove("parkendaToken");
                    this.$router.push("/login");
                  }
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      }
    };
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped>
.footer {
  height: 35vh;
}
.pay {
  background-color: rgba(114, 174, 255, 1);
  color: white;
}
.cancel {
  background-color: #fbae31;
  color: white;
}
.back_button {
  background-color: white;
  color: #fbae31;
}
</style>



// WEBPACK FOOTER //
// src/components/RequestCar/InProgress.vue